var _circle, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStep3Icon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 141,
    viewBox: "0 0 45 141",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "url(#paint0_linear_2228_1265)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.29 32.3C15.72 32.3 12.75 29.63 12.75 25.19V24.71H17.52V25.19C17.52 27.23 18.09 27.98 22.08 27.98C25.86 27.98 27.03 27.38 27.03 25.64C27.03 24.14 26.07 23.51 24.18 23.51H18.39V19.82H23.76C25.5 19.82 26.28 19.19 26.28 17.93C26.28 16.52 25.44 15.92 22.02 15.92C18.42 15.92 17.52 16.67 17.52 18.71V18.86H12.75V18.71C12.75 14.48 15.87 11.6 22.41 11.6C27.78 11.6 30.75 13.43 30.75 16.97C30.75 19.28 29.37 20.84 26.76 21.17V21.5C29.7 21.92 31.62 23.42 31.62 26.36C31.62 30.26 28.14 32.3 22.29 32.3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 55L22 140",
    stroke: "url(#paint1_linear_2228_1265)",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2228_1265",
    x1: 0,
    y1: 22.5,
    x2: 45,
    y2: 22.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2228_1265",
    x1: 20.5,
    y1: 55,
    x2: 20.5,
    y2: 140,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2069FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003CB7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3Icon);
export default __webpack_public_path__ + "static/media/step3Icon.82cae497d8744f39bbc17f46b79cc9cc.svg";
export { ForwardRef as ReactComponent };